import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminPermissions } from '@/hooks/admin/useAdminPermissions';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

interface DataAccessGuardProps {
    children: React.ReactNode;
    fallback?: React.ReactNode;
}

export const DataAccessGuard: React.FC<DataAccessGuardProps> = ({ children, fallback }) => {
    const { permissions, loading } = useAdminPermissions();

    if (loading) {
        return (
            <div className="flex justify-center items-center min-h-screen">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
                    <p className="mt-2 text-gray-600">Checking permissions...</p>
                </div>
            </div>
        );
    }

    if (!permissions.canViewAllData) {
        if (fallback !== undefined) return <>{fallback}</>;
        return (
            <div className="flex justify-center items-center min-h-screen bg-gray-50">
                <Card className="w-full max-w-md">
                    <CardHeader className="text-center">
                        <CardTitle className="text-red-600">Access Restricted</CardTitle>
                        <CardDescription>
                            Access to engineering or admin users.
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="text-center">
                        <button
                            onClick={() => (window.history.length > 1 ? window.history.back() : (window.location.href = '/dashboard'))}
                            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
                        >
                            Go Back
                        </button>
                    </CardContent>
                </Card>
            </div>
        );
    }

    return <>{children}</>;
};
